import React from 'react'
import { useTranslation } from 'react-i18next'

function getNotificationMessage() {
  return 'mobilePaymentsThankYouMessage'
}

function PaymentsSuccessPage(props) {
  const { t } = useTranslation()

  const notificationMessage = getNotificationMessage()

  return (
    <div className="container light-green-bg">
      <div className="row justify-content-center text-center">
        <div className="col-5 mt-5">
          <div>
            <img onClick={() => props.history.push('/start')} src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        </div>
      </div>
      <div className="text-center light-green-bg">
        <div className="resumo-header">
          <h2 className="title"><b>{t('mobilePaymentsThankYouTitle')}</b></h2>
          <h2 className="title">{t('mobilePaymentsThankYouSubTitle')}</h2>
          <p className="p-4 color-grey font-weight-light">{t(notificationMessage)}</p>
        </div>
      </div>
      <div className="finish-button" onClick={() => props.history.push(`/rating`)}>
        {t('opinionButton')}
      </div>
    </div>
  )
}

export default PaymentsSuccessPage
